export function getPrices(state) {
  return state.prices;
}